/**
 * Copyright 2022 (C) Blink - All Rights Reserved
 *
 * This source code is protected under international copyright law.  All rights
 * reserved and protected by the copyright holders.
 * All files are confidential and only available to authorized individuals with the
 * permission of the copyright holders. If you encounter any file and do not have
 * permission, please get in touch with the copyright holders and delete this file.
 */
import cn from "classnames";

import s from "./Spinner.module.css";

interface ISpinner {
  className?: string;
  size?: "lg" | "sm" | "xs" | "xl";
  variant?: "gray" | "blue";
  svgClassName?: string;
}

const Spinner = ({
  className,
  size = "lg",
  variant = "gray",
  svgClassName,
}: ISpinner) => {
  const sizeClass = s[size];
  if (size === "xs") {
    return (
      <span className={cn("w-fit")} test-id="Rzx9VVlz">
        <svg
          className={cn("animate-spin h-5 w-5 text-current", svgClassName)}
          xmlns="http://www.w3.org/2000/svg"
          fill="none"
          viewBox="0 0 24 24"
          test-id="wqn-27aH"
        >
          <circle
            className="opacity-25"
            cx="12"
            cy="12"
            r="10"
            stroke={variant}
            strokeWidth="4"
            test-id="xHM7AuXx"
          ></circle>

          <path
            className="opacity-75"
            fill={variant}
            d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"
            test-id="EQGZiY2K"
          ></path>
        </svg>
      </span>
    );
  }

  return (
    <div className={cn(className, "z-[1]")} test-id="XJghfmDx">
      <span
        className={cn(s.loader, sizeClass, s[variant])}
        test-id="CfkCM0u7"
      />
    </div>
  );
};

export default Spinner;
